/** The 9:16 window cut from the middle of a frame, in the frame's own pixels, never upscaled. */
export function portraitCrop(width: number, height: number): { x: number; y: number; width: number; height: number } {
  const even = (n: number) => Math.max(2, Math.floor(n / 2) * 2);
  const w = width / height > 9 / 16 ? even((height * 9) / 16) : even(width);
  const h = width / height > 9 / 16 ? even(height) : even((width * 16) / 9);
  return { x: Math.floor((width - w) / 2), y: Math.floor((height - h) / 2), width: w, height: h };
}
